// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain as CartChain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import {
    chain as CurrentCartChain,
    GetCart as GetCurrentCart,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain as OrderApprovalChain,
    RequestDataFromApi as GetOrder,
} from "@insite/client-framework/Store/Data/OrderApprovals/Handlers/LoadOrderApproval";
import {
    chain as LoadOrderByOrderNumber,
    RequestDataFromApi as GetOrderByNumber,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import {
    chain as GetQuoteChain,
    DispatchCompleteLoadQuote,
} from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import {
    chain as LoadRequisitions,
    RequestDataFromApi as GetRequisitions,
} from "@insite/client-framework/Store/Data/Requisitions/Handlers/LoadRequisitions";
import {
    chain as loadOrder,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";
import {
    chain as RequisitionChain,
    GetCart as LoadRequisition,
} from "@insite/client-framework/Store/Pages/RequisitionConfirmation/Handlers/LoadCart";

type HandlerType = Parameters<
    typeof GetCart | typeof GetCurrentCart | typeof GetOrder | typeof DispatchCompleteLoadQuote
>[0];

export const UpdateNonStockLines = (props: any) => {
    let lines;
    if ("cart" in props.apiResult) {
        lines = props.apiResult.cart?.cartLines;
    } else {
        lines = props.apiResult?.cartLines;
    }

    if (!lines) {
        lines = props.apiResult?.orderLines;
    }

    lines?.every((line: any) => {
        if (line.properties.nonStockProductDescription || line.properties.nonStockProductErpNumber) {
            line.productUri = "";
            line.brand = null;
            line.shortDescription = line.properties.nonStockProductDescription || line.shortDescription;
            line.altText = line.properties.nonStockProductDescription || line.altText;
            line.manufacturerItem = "";
            line.customerName = "";
            line.properties.hideOutofStockMessage = "";
            line.properties.leadTimeMessage = "";
        }
        return true;
    });
};

export const UpdateNonStockRequisitionsLines = (props: any) => {
    const requisitions = props.apiResult.requisitions;
    requisitions?.every((line: any) => {
        if (line.properties.nonStockProductDescription || line.properties.nonStockProductErpNumber) {
            line.productUri = "";
            line.brand = null;
            line.shortDescription = line.properties.nonStockProductDescription || line.shortDescription;
            line.altText = line.properties.nonStockProductDescription || line.altText;
            line.manufacturerItem = "";
            line.customerName = "";
            line.properties.hideOutofStockMessage = "";
            line.properties.leadTimeMessage = "";
        }
        return true;
    });
};

addToChainAfter(CartChain, GetCart, UpdateNonStockLines);
addToChainAfter(CurrentCartChain, GetCurrentCart, UpdateNonStockLines);
addToChainAfter(OrderApprovalChain, GetOrder, UpdateNonStockLines);
addToChainBefore(GetQuoteChain, DispatchCompleteLoadQuote, UpdateNonStockLines);
addToChainAfter(LoadOrderByOrderNumber, GetOrderByNumber, UpdateNonStockLines);
addToChainAfter(RequisitionChain, LoadRequisition, UpdateNonStockLines);
addToChainAfter(LoadRequisitions, GetRequisitions, UpdateNonStockRequisitionsLines);
addToChainAfter(loadOrder, RequestDataFromApi, UpdateNonStockLines);
